import { Card, Classes, H1 } from "@blueprintjs/core";
import ReactEcharts from "echarts-for-react";
import React from "react";

const LoadingCard = () => {
  return (
    <Card style={{ height: "100%" }}>
      <H1 className={Classes.SKELETON}>loading..</H1>
      <p className={Classes.SKELETON}>loading..</p>
      <p className={Classes.SKELETON}>loading..</p>
      <p className={Classes.SKELETON}>loading..</p>
      <p className={Classes.SKELETON}>loading..</p>
    </Card>
  );
};

const EmptyCard = () => {
  return (
    <Card style={{ height: "100%" }}>
      <H1>Data Tidak ada</H1>
      <p>Maaf data yang dicari tidak ditemukan</p>
    </Card>
  );
};

// render echarts option.
export default function SPie({ loading, data, title, subText }) {
  if (loading) {
    return <LoadingCard />;
  }

  if (data) {
    if (Array.isArray(data) && data.length === 0) {
      return <EmptyCard />;
    }

    const { __typename, ...result } = data;
    const isFuckingNull = Object.values(result).every((d) => d === null);

    const usia = Object.values(result);
    const listUsia = ["<20", "20-29", "30-39", "40-49", "50-55", ">55"];

    const hasil = {
      title: {
        text: `${title || "Kosong"}`,
        subtext: `${subText || "Kosong"}`,
        subtextStyle: {
          fontSize: 9,
        },
      },
      legend: {
        data: listUsia,
        type: "scroll",
        orient: "horizontal",
        bottom: 20,
      },
      toolbox: {
        show: true,
        feature: { saveAsImage: { type: "svg", title: "Unduh Chart" } },
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)",
      },
      series: [
        {
          name: "Usia",
          type: "pie",
          radius: ["50%", "60%"],
          avoidLabelOverlap: false,
          label: {
            formatter: "{a} {b} {c} org. {d}%",
            backgroundColor: "#eee",
            borderColor: "#aaa",
            borderWidth: 1,
            borderRadius: 4,
            rich: {
              a: {
                color: "#999",
                lineHeight: 10,
                align: "center",
              },
              hr: {
                borderColor: "#aaa",
                width: "100%",
                borderWidth: 0.5,
                height: 0,
              },
              b: {
                fontSize: 10,
                lineHeight: 10,
              },
              per: {
                color: "#eee",
                backgroundColor: "#334455",
                padding: [2, 4],
                borderRadius: 2,
              },
            },
          },

          data: listUsia.map((k, i) => ({ name: k, value: usia[i] })),
        },
      ],
    };
    return (
      <React.Fragment>
        {isFuckingNull ? (
          <EmptyCard />
        ) : (
          <Card style={{ height: "100%" }}>
            <ReactEcharts
              style={{ height: "100%", width: "100%" }}
              option={hasil}
              opts={{ renderer: "svg" }}
            />
          </Card>
        )}
      </React.Fragment>
    );
  }
}
